export var OptimizerTriggerDuration;
(function (OptimizerTriggerDuration) {
    OptimizerTriggerDuration["EVERY_1_HOUR"] = "EVERY_1_HOUR";
    OptimizerTriggerDuration["EVERY_4_HOURS"] = "EVERY_4_HOURS";
    OptimizerTriggerDuration["EVERY_6_HOURS"] = "EVERY_6_HOURS";
    OptimizerTriggerDuration["EVERY_8_HOURS"] = "EVERY_8_HOURS";
    OptimizerTriggerDuration["EVERY_1_DAY"] = "EVERY_1_DAY";
    OptimizerTriggerDuration["EVERY_10_MINUTES"] = "EVERY_10_MINUTES";
    OptimizerTriggerDuration["EVERY_30_MINUTES"] = "EVERY_30_MINUTES";
})(OptimizerTriggerDuration || (OptimizerTriggerDuration = {}));
//# sourceMappingURL=optimizers.enum.js.map